import { useTranslation } from "react-i18next";
import carinho from "../../../assets/carinho.png";
import mapa from "../../../assets/mapa_brasil.png";
import transporte from "../../../assets/export_import.png";
import sustentabilidade from "../../../assets/sustentabilidade.png";

export default function Cards() {
  const { t } = useTranslation();

  return (
    <section id="cards_home" className="cards">
      <div>
        <img src={carinho} alt="Castanhas Selecionadas com Carinho" />
        <h2>{t("home.cards.card1.titulo")}</h2>
        <p>{t("home.cards.card1.descricao")}</p>
      </div>
      <div>
        <img src={sustentabilidade} alt="Sustentabilidade" />
        <h2>{t("home.cards.card2.titulo")}</h2>
        <p>{t("home.cards.card2.descricao")}</p>
      </div>
      <div>
        <img src={transporte} alt="Transporte Seguro" />
        <h2>{t("home.cards.card3.titulo")}</h2>
        <p>{t("home.cards.card3.descricao")}</p>
      </div>
      <div>
        <img src={mapa} alt="Mapa do Brasil" />
        <h2>{t("home.cards.card4.titulo")}</h2>
        <p>{t("home.cards.card4.descricao")}</p>
      </div>
    </section>
  );
}
